module.exports = __webpack_public_path__ + "static/media/light-theme-fuel-fill.f84f0e09.svg";